var glideMulti = new Glide('.md_featured_grid .glide.multi', {
    type: 'carousel',
    autoplay: 4000,
    focusAt: 'center',
    perView: 1,
    focusAt: '1',
    gap: 0,
    peek: {
        before: 32,
        after: 32
    }
});  
var glideMulti2 = new Glide('.md_ugc_grid .glide.multi', {
    type: 'carousel',
    focusAt: 'center',
    perView: 1,
    focusAt: '1',
    gap: 16,
    peek: {
        before: 50,
        after: 50
    }
});
var glideMulti3 = new Glide('.md_experts .glide.multi', {
    type: 'carousel',
    autoplay: 4000,
    focusAt: 'center',
    perView: 1,
    focusAt: '1',
    gap: 16,
    peek: {
        before: 50,
        after: 50
    }
});
var glideMulti4 = new Glide('.md_reviews_slider .glide.multi', {
    type: 'carousel',
    autoplay: 4000,
    focusAt: 'center',
    perView: 3,
    focusAt: '1',
    gap: 16,
    breakpoints: {
        600: {
            perView: 1
        }
    }
});
 
var glideMulti5 = new Glide('.md_product_images_carousel .glide.multi', {
    type: 'carousel',
    perView: 1
});
var glideMulti6 = new Glide('.md_whats_inside_carousel .glide.multi', {
    type: 'carousel',
    perView: 1
});
var glideMulti7 = new Glide('.md_various_infos .glide.multi', {
    type: 'carousel',
    perView: 1
});

glideMulti2.on('run.after', () => {
    $('.mg_ugc_video_play').show();
    $('.md_ugc_cell_info').show();
    $('.md_ugcs_poster_outside').show();
    $('.md_ugc_cell').find('video').each(function() {
        this.pause(); 
    });
});


function safeMount(glideInstance, selector) {
    if (document.querySelector(selector)) {
        try {
            glideInstance.mount();
        } catch (error) {
            console.warn(`Failed to mount carousel ${selector}:`, error);
        }
    }
}


safeMount(glideMulti4, '.md_reviews_slider .glide.multi');
safeMount(glideMulti2, '.md_ugc_grid .glide.multi');
safeMount(glideMulti, '.md_featured_grid .glide.multi');
safeMount(glideMulti3, '.md_experts .glide.multi');
safeMount(glideMulti5, '.md_product_images_carousel .glide.multi');
safeMount(glideMulti6, '.md_whats_inside_carousel .glide.multi');
safeMount(glideMulti7, '.md_various_infos .glide.multi');